import React from 'react';
import { Row, Col, Card } from 'antd';
import car1 from './car1.png';
import car2 from './car2.png';
import car3 from './car3.png';
import car4 from './car4.png';
import car5 from './car5.png';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { routes } from '../../routes/main.routes';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './car-gallery.component.scss';
import { Carousel } from 'react-responsive-carousel';
import { mobileDetection } from '../../utils/is-mobile';

const { Meta } = Card;
const cars = [
  { image: car1, title: 'Jeep' },
  { image: car2, title: 'Tesla' },
  { image: car3, title: 'Mercedes-Benz' },
  { image: car4, title: 'Porsche' },
  { image: car5, title: 'BMW' },
];

const CarCard: React.FC<{ image: string; title: string; hoverable?: boolean }> = function ({
  image,
  title,
  hoverable,
}) {
  const navigate = useNavigate();
  const clickHandler = () => {
    navigate(routes.vehicles.path);
  };

  return (
    <StyledCard
      hoverable={hoverable}
      onClick={clickHandler}
      cover={<img alt={title} src={image} />}
      className="card-wrapper"
    >
      <Meta title={title} style={{ textAlign: 'center' }} />
    </StyledCard>
  );
};

const CarGallery: React.FC = function () {
  const [isMobile] = React.useState(mobileDetection());

  if (isMobile) {
    return (
      <Row justify="space-around" align="middle">
        <Carousel
          className="carousel-wrapper"
          showThumbs={false}
          showIndicators={false}
          width={'242px'}
          showStatus={false}
          swipeable={true}
          emulateTouch={true}
          showArrows={false}
        >
          {cars.map((car) => {
            return <CarCard image={car.image} title={car.title} key={car.title} />;
          })}
        </Carousel>
      </Row>
    );
  }

  return (
    <Row justify="space-around" align="middle">
      {cars.map((car) => {
        return (
          <Col key={car.title} xs={24} md={4}>
            <CarCard hoverable image={car.image} title={car.title} />
          </Col>
        );
      })}
    </Row>
  );
};

const StyledCard = styled(Card)`
  && {
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  }
`;

export default CarGallery;
